import Validatorjs from 'validatorjs'
import dvr from 'mobx-react-form/lib/validators/DVR'
import createFields from './fieldDeclarationGenerator'
import { FormzFormMaker } from '../../formState'

const plugins = {
  dvr: dvr(Validatorjs),
}

const generateNewField = (fieldType, initialValues = {}, options = {}) => {
  const fields = createFields(fieldType, initialValues, {}, options)

  const hooks = {
    onSuccess() {},
    onError() {},
  }
  const formOptions = { validateOnChange: true }
  return {
    // notice that we are not using the default Mobx-form class
    form: new FormzFormMaker(
      { fields },
      { plugins, options: formOptions, hooks }
    ),
    id: fields.find((item) => item.name === 'id').value,
  }
}

export default generateNewField
